/** A cover sheet is a PDF or image. It holds no patient values. */

export const COVER_MIMES = ['application/pdf', 'image/png', 'image/jpeg'] as const;

export type CoverMime = (typeof COVER_MIMES)[number];

export type CoverFilePayload = {
  bytes: Uint8Array;
  mime: CoverMime;
  ext: 'pdf' | 'png' | 'jpg';
};

const MAX_COVER_BYTES = 20 * 1024 * 1024;

export async function readCoverFile(file: File): Promise<CoverFilePayload> {
  if (file.size <= 0 || file.size > MAX_COVER_BYTES) throw new Error('cover-type');
  const bytes = new Uint8Array(await file.arrayBuffer());
  const sniffed = sniffCover(bytes);
  if (!sniffed) throw new Error('cover-type');
  return { bytes, ...sniffed };
}

export function sniffCover(bytes: Uint8Array): Pick<CoverFilePayload, 'mime' | 'ext'> | null {
  if (
    bytes.length >= 4 &&
    bytes[0] === 0x25 &&
    bytes[1] === 0x50 &&
    bytes[2] === 0x44 &&
    bytes[3] === 0x46
  ) {
    return { mime: 'application/pdf', ext: 'pdf' };
  }
  if (
    bytes.length >= 8 &&
    bytes[0] === 0x89 &&
    bytes[1] === 0x50 &&
    bytes[2] === 0x4e &&
    bytes[3] === 0x47
  ) {
    return { mime: 'image/png', ext: 'png' };
  }
  if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
    return { mime: 'image/jpeg', ext: 'jpg' };
  }
  return null;
}
